import { useUserContext } from 'contexts/users/User.context';

export const useOrganizationPermissions = () => {
  const { user } = useUserContext();

  return user?.organization.myPermissions || [];
};
